/* eslint-disable no-unused-vars,no-const-assign,consistent-return,no-param-reassign,react/jsx-props-no-spreading */
import React, { useState } from "react";
import { v4 as uuid } from "uuid";
import { Input, DatePicker, Button, Row, Col, Table, Collapse, Pagination, Form } from "antd";
import "../../styles/filters-form.less";
import "./RejectedTrafficDetail.less";
import { useSelector } from "react-redux";
import {
  displayFormat,
  toDisplayFormatWithTime,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";
import TablePageSelect from "../TablePageSelect/TablePageSelect";
import { checkIsLoaded, checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import ToggleColumns from "../ToggleableVersionsTable/ToggleColumns";

const dateFormat = displayFormat;
const { RangePicker } = DatePicker;

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const buttonLayout = {
  wrapperCol: { span: 24 },
};

const RejectedTrafficDetail = ({
  dataDetails,
  rejectedTrafficsDetail,
  rejectedTrafficsDetailLoading,
  getValueRejectedTrafficDetailPagingAndFilters,
  handleSearchRejectsTraffic,
  resetSearchRejectsTraffic,
  handlePageSize,
  form,
  rejectedTrafficDetailSearchParams,
  rejectParams,
}) => {
  const [filtersCollapseState, setFiltersCollapsState] = useState("unfolded");
  const { Panel } = Collapse;
  const trafficStatuses = useSelector((state) => state.rtkDictionaries.trafficStatus);

  const getTableHeight = () => (filtersCollapseState === "unfolded" ? `${62}vh` : `${65}vh`);

  const toggleFiltersCollapseState = () => {
    const newState = filtersCollapseState === "unfolded" ? "folded" : "unfolded";
    setFiltersCollapsState(newState);
  };

  const getRoleTableName = () => {
    let name = "";
    if (dataDetails) {
      if (dataDetails?.role === "SENDER") {
        name = "Статус по отправителю";
      }
      if (dataDetails?.role === "RECIPIENT") {
        name = "Статус по получателю";
      }
    } else {
      name = "Статус";
    }
    return name;
  };

  const getPanelHeader = () =>
    filtersCollapseState === "unfolded" ? (
      ""
    ) : (
      <div className="bulk__panel_header">Показать фильтры</div>
    );

  const renderFilters = () => (
    <div className="reject-filters">
      <Row>
        <Col span={7}>
          <Form.Item label="ID документа" name="includeDocumentIds">
            <Input placeholder="Введите значение" allowClear />
          </Form.Item>
        </Col>
        <Col span={7} offset={1}>
          <Form.Item label="Дата документа" name="rangeDate">
            <RangePicker style={{ width: "100%" }} format={dateFormat} allowClear={false} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={11} offset={12}>
          <Form.Item {...buttonLayout} style={{ textAlign: "right", marginBottom: 0 }}>
            <Button onClick={resetSearchRejectsTraffic}>Сброс параметров</Button>
            <Button
              htmlType="submit"
              loading={checkIsLoading(rejectedTrafficsDetailLoading)}
              type="primary"
            >
              Применить
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </div>
  );

  const pageSizeOptions = {
    20: 20,
    50: 50,
    100: 100,
  };

  const [columns, setColumns] = useState([
    {
      title: "Аккаунт отправителя",
      dataIndex: "senderAccountName",
      key: "senderAccountName",
      hidden: false,
      width: "160px",
    },
    {
      title: "Аккаунт получателя",
      dataIndex: "recipientAccountName",
      key: "recipientAccountName",
      hidden: false,
      width: "160px",
    },
    {
      title: "ID отправителя",
      dataIndex: "senderSubscriberId",
      key: "senderSubscriberId",
      hidden: false,
      width: "100px",
    },
    {
      title: "ID получателя",
      dataIndex: "recipientSubscriberId",
      key: "recipientSubscriberId",
      hidden: false,
      width: "100px",
    },
    {
      title: "Тех. ID отправителя",
      dataIndex: "senderSubscriber",
      key: "senderSubscriber",
      hidden: false,
      width: "100px",
    },
    {
      title: "Тех. ID получателя",
      dataIndex: "recipientSubscriber",
      key: "recipientSubscriber",
      hidden: false,
      width: "100px",
    },
    {
      title: getRoleTableName(),
      dataIndex: "serviceUsageStatusId",
      key: "serviceUsageStatusId",
      hidden: false,
      width: "160px",
    },
    {
      title: "Дата обработки",
      dataIndex: "eventDate",
      key: "eventDate",
      hidden: false,
      width: "160px",
    },
    {
      title: "Дата документа",
      dataIndex: "documentDate",
      key: "documentDate",
      hidden: false,
      width: "160px",
    },
    {
      title: "Имя документа",
      dataIndex: "documentName",
      key: "documentName",
      hidden: false,
      width: "160px",
    },
    {
      title: "ID документа",
      dataIndex: "documentId",
      key: "documentId",
      hidden: false,
      width: "160px",
    },
    {
      title: "Продукт",
      dataIndex: "serviceType",
      key: "serviceType",
      hidden: true,
      width: "100px",
    },
    {
      title: "Подписан",
      dataIndex: "signed",
      key: "signed",
      hidden: true,
      width: "80px",
    },
    {
      title: "Размер",
      dataIndex: "documentSize",
      key: "documentSize",
      hidden: true,
      width: "80px",
    },
    {
      title: "Тип содержания",
      dataIndex: "documentType",
      key: "documentType",
      hidden: true,
      width: "100px",
    },
    {
      title: "Тег отправителя",
      dataIndex: "senderTags",
      key: "senderTags",
      hidden: true,
      width: "100px",
    },
    {
      title: "Тег получателя",
      dataIndex: "recipientTags",
      key: "recipientTags",
      hidden: true,
      width: "100px",
    },
    {
      title: "Тип",
      dataIndex: "processingType",
      key: "processingType",
      hidden: true,
      width: "80px",
    },
  ]);

  const filterColumns = [...columns].filter((item) => !item.hidden);

  let tableData;

  if (filterColumns && filterColumns.length) {
    tableData =
      checkIsLoaded(rejectedTrafficsDetailLoading) &&
      rejectedTrafficsDetail &&
      rejectedTrafficsDetail?.content.map((detail) => ({
        key: uuid(),
        recipientAccountName: detail?.recipientAccountName,
        senderAccountName: detail?.senderAccountName,
        senderSubscriberId: detail?.senderSubscriberId,
        recipientSubscriberId: detail?.recipientSubscriberId,
        senderSubscriber: detail?.senderSubscriber,
        recipientSubscriber: detail?.recipientSubscriber,
        serviceUsageStatusId:
          trafficStatuses &&
          trafficStatuses.find((item) => item.id === detail?.serviceUsageStatusId)?.name,
        eventDate: detail?.eventDate ? toDisplayFormatWithTime(detail?.eventDate) : "",
        documentDate: detail?.documentDate ? toDisplayFormatWithTime(detail?.documentDate) : "",
        documentName: detail?.documentName,
        documentId: detail?.documentId,
        serviceType: detail?.serviceType,
        signed: detail?.signed ? "Да" : "Нет",
        documentSize: detail?.documentSize,
        documentType: detail?.documentType,
        senderTags: detail?.senderTags.map((item) => item),
        recipientTags: detail?.recipientTags.map((item) => item),
        processingType: detail?.processingType,
      }));
  }

  return (
    <div className="container_height">
      <Form
        form={form}
        labelAlign="left"
        initialValues={rejectedTrafficDetailSearchParams}
        {...layout}
        onFinish={(values) => {
          if (values) {
            values.page = 0;
            values.size = rejectParams.size;
            values.fromDate = toHttpFormatStartOfDay(values.rangeDate[0]);
            values.toDate = toHttpFormatEndOfDay(values.rangeDate[1]);
            values.senderSubscribers =
              dataDetails?.role === "SENDER" ? dataDetails?.subscriber : "";
            values.recipientSubscribers =
              dataDetails?.role === "RECIPIENT" ? dataDetails?.subscriber : "";
            values.includeServiceUsageStatusIds = dataDetails
              ? dataDetails?.serviceUsageStatusId
              : "";
            values.rangeDate = "";
          }
          handleSearchRejectsTraffic(values);
        }}
      >
        <div className="inner-row">
          <Row justify="space-between" align="middle">
            <Col>
              <h1>Детализация</h1>
            </Col>
          </Row>
          <Collapse
            defaultActiveKey="1"
            onChange={toggleFiltersCollapseState}
            expandIconPosition="right"
            className="filter-collapse"
          >
            <Panel header={getPanelHeader()} key="1">
              {renderFilters()}
            </Panel>
          </Collapse>
        </div>

        <Row justify="end" align="middle" className="reject-form__pagination">
          <Col span={14}>
            <Row justify="center">
              <Pagination
                onChange={(e) => handlePageSize("page", e)}
                current={getValueRejectedTrafficDetailPagingAndFilters("page") + 1}
                total={rejectedTrafficsDetail && rejectedTrafficsDetail?.totalElements}
                pageSize={getValueRejectedTrafficDetailPagingAndFilters("size")}
                hideOnSinglePage
                size="small"
                showSizeChanger={false}
              />
            </Row>
          </Col>
          <Col span={5} style={{ paddingRight: "5px" }}>
            <Row justify="end" align="middle" wrap={false}>
              <Col style={{ marginRight: "15px" }}>
                <TablePageSelect
                  onChange={(e) => handlePageSize("size", e)}
                  value={getValueRejectedTrafficDetailPagingAndFilters("size")}
                  pageSizeOptions={pageSizeOptions}
                />
              </Col>
              <ToggleColumns
                tableName="rejected-traffic-detail-table"
                columns={columns}
                setColumns={setColumns}
              />
            </Row>
          </Col>
        </Row>
      </Form>
      <Table
        size="small"
        loading={checkIsLoading(rejectedTrafficsDetailLoading)}
        columns={filterColumns}
        // className="rejected-traffic-detail-table"
        dataSource={tableData}
        pagination={false}
        scroll={{ y: getTableHeight(), x: true }}
      />
    </div>
  );
};

export default RejectedTrafficDetail;
